// extracted by mini-css-extract-plugin
export default {"shellActionsButtons":"ButtonsActions_shellActionsButtons__AVcDO"};